import { CertificationStatus } from '../data-models/certification-status.model';
import { CertificationTypeInfo } from '../response-models/certification-type-info.model';

/**
 * Organization certification types
 */
export const ORGANIZATION_CERTIFICATION_TYPES: CertificationTypeInfo[] = [
  {
    value: 'faa-44807',
    label: 'FAA 44807 Exemption',
    description: 'Section 44807 exemption for commercial drone operations',
    ownerType: 'organization',
    isRequired: true
  },
  {
    value: 'faa-part-137',
    label: 'FAA Part 137',
    description: 'Agricultural aircraft operations certificate',
    ownerType: 'organization',
    isRequired: true
  },
  {
    value: 'insurance',
    label: 'Liability Insurance',
    description: 'Commercial liability insurance for drone operations',
    ownerType: 'organization',
    isRequired: true
  },
  {
    value: 'medical',
    label: 'Medical Certificate',
    description: 'FAA medical certificate',
    ownerType: 'organization',
    isRequired: false
  },
  {
    value: 'state-applicator',
    label: 'State Applicator License',
    description: 'State-issued pesticide applicator license',
    ownerType: 'organization',
    isRequired: true
  },
  {
    value: 'other',
    label: 'Other',
    description: 'Additional certification, license, or credential',
    ownerType: 'organization',
    isRequired: false
  },
];

/**
 * User (Profile) certification types
 */
export const USER_CERTIFICATION_TYPES: CertificationTypeInfo[] = [
  {
    value: 'faa-part-107',
    label: 'FAA Part 107',
    description: 'Remote Pilot Certificate for small UAS',
    ownerType: 'profile',
    isRequired: true
  },
  {
    value: 'faa-part-108',
    label: 'FAA Part 108',
    description: 'Future remote pilot certification (coming soon)',
    ownerType: 'profile',
    isRequired: false
  },
  {
    value: 'state-applicator',
    label: 'State Applicator License',
    description: 'State-issued pesticide applicator license',
    ownerType: 'profile',
    isRequired: true
  },
  {
    value: 'medical',
    label: 'Medical Certificate',
    description: 'FAA medical certificate',
    ownerType: 'profile',
    isRequired: false
  },
  {
    value: 'other',
    label: 'Other',
    description: 'Additional certification, license, or credential',
    ownerType: 'profile',
    isRequired: false
  },
];

export function getCertificationStatus(
  status: CertificationStatus | null | undefined, 
  expirationDate: string | null | undefined
): string {
  if (!status) { 
    return 'Unknown';
  }

  if (status === 'archived') {
      return status;
  }

  if (expirationDate) {
    const expDate = new Date(expirationDate);
    const now = new Date();
    const thirtyDaysFromNow = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);

    if (expDate < now) {
      return 'expired';
    }
    else if (expDate < thirtyDaysFromNow) {
      return 'expiring-soon';
    }
    
    return 'active';
  }

  return status;
}
